import SeatInfo from './SeatInfo';
import { SeatInfoProps, SeatInfoValueProps } from './types';

export type { SeatInfoProps, SeatInfoValueProps };
export default SeatInfo;
